import React, { useContext } from "react";
import { FormContext } from "./Form";
import { Informative } from "../../Inputs/General/Index";
import { InvoiceProviderNumberArea } from "./Styles";

export default function InvoiceProvider({ value, className = "" }) {
  /**
   * @type {{
   *    document:import("types/typedef/documents").DocumentI
   * }}
   */
  const { document } = useContext(FormContext);

  return (
    <>
      {className !== "" ? (
        <div>
          <Informative
            readonly={true}
            label="Fact. proveedor"
            value={!value ? "ND-Por programar" : value}
          />
        </div>
      ) : (
        <InvoiceProviderNumberArea>
          <Informative
            readonly={true}
            label="Fact. proveedor"
            value={!value ? "ND-Por programar" : value}
          />
        </InvoiceProviderNumberArea>
      )}
    </>
  );
}
